<template>
  <div class="profile-hero">
    <ProfileImage
      :source="userData.profile_pic || userData.big_thumbnail"
      :accountActive="!userData.accountNotActivated"
    />
    <div class="column">
      <div class="mb-2">
        <label>Geburtsdatum</label>
        <b>{{ formatDate }} ({{ dateToAge }})</b>
      </div>
      <div class="mb-2">
        <label>Tätig für</label>
        <b>{{ userData.working_for }}</b>
      </div>
      <div class="mb-2">
        <label>Tätig seit</label>
        <b>{{ userData.working_since ? formatSinceDate : 'k.A.' }}</b>
      </div>
    </div>

    <div v-if="userData.scoutarea" class="column">
      <div class="mb-2">
        <label for>Nationalität</label>
        <b>
          <flag class="flag" :iso="userData.nationality" />
          {{ getNationality }}
        </b>
      </div>
      <div class="mb-2">
        <label>Scoutgebiet</label>
        <div v-for="(gebiet, i) in userData.scoutarea" :key="i">
          <span class="font-weight-bold d-block">{{ gebiet }}</span>
        </div>
      </div>
    </div>

    <div class="column">
      <div class="mb-2" v-if="userData.living_in_country">
        <label>Wohnsitz (Land)</label>
        <flag class="flag" :iso="getCountryShort" />
        <b>{{ userData.living_in_country }}</b>
      </div>
      <div class="mb-2">
        <label>Scoutbereich</label>
        <span v-for="(land, i) in userData.bundesland" :key="i">
          <span class="font-weight-bold d-block">{{ land }}</span>
        </span>
      </div>
    </div>

    <ProfilLinks :userData="userData" />

    <div class="column-span mt-2 pb-2">
      <label>Bio</label>
      {{ userData.bio }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ProfileImage from './ProfileImage';
import ProfilLinks from './ProfilLinks';

export default {
  name: 'profile-user-data',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    ProfileImage,
    ProfilLinks,
  },

  computed: {
    formatDate() {
      if (!this.userData.age) return null;

      const [year, month, day] = this.userData.age.split('-');
      return `${day}.${month}.${year}`;
    },

    dateToAge() {
      if (!this.userData.age) return null;
      const [year, month, day] = this.userData.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const age = moment().diff(dateString, 'years');
      return age;
    },

    getNationality() {
      if (this.userData.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.userData.nationality,
        );
        return found.item_text;
      }
      return '';
    },

    getCountryShort() {
      const found = this.$store.state.nationalities.find(
        (element) => element.item_text === this.userData.living_in_country,
      );
      return found.id;
    },

    formatSinceDate() {
      return this.userData.working_since
        ? moment(this.userData.working_since).format('MM/YYYY')
        : '';
    },
  },
};
</script>
